import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.set-prototype-of";
import _get from "lodash/get";
import _bindAll from "lodash/bindAll";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint-disable no-return-assign */

/**
 * Presentational component which renders input and suggested results.
 */
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames'; // eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration

import sanitizeHtml from 'sanitize-html';
import { Impression } from '@nerdwallet/analytics/react/impression';
import LegacyInput from '@nerdwallet/react-input/dist/legacy';
import Search from '@nerdwallet/react-icon/gizmo/Search';
import LoadingSpinner from '@nerdwallet/react-loading-spinner';
import { ElementImpressionInteraction } from '@nerdwallet/nw-client-lib/tracking';
import { Card } from '../../lib/prop-types';
import './autocomplete-search.less';

var AutocompleteSearch =
/*#__PURE__*/
function (_Component) {
  _inherits(AutocompleteSearch, _Component);

  function AutocompleteSearch(props) {
    var _this;

    _classCallCheck(this, AutocompleteSearch);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AutocompleteSearch).call(this, props));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "positionDropdown", function () {
      var _assertThisInitialize = _assertThisInitialized(_assertThisInitialized(_this)),
          container = _assertThisInitialize.container;

      _this.resultsContainer.style.maxWidth = "".concat(container.offsetWidth, "px");
    });

    _this.state = {
      inputValue: '',
      currentHoverIndex: null,
      hideList: true
    };

    _bindAll(_assertThisInitialized(_assertThisInitialized(_this)), ['handleTypeaheadInput', 'handleClick', 'handleKeyDown', 'handleMouseOver', 'handleMouseLeave', 'handleFocus', 'handleBlur', 'transitionHoverState', 'isElementInContainer']);

    return _this;
  }

  _createClass(AutocompleteSearch, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('resize', this.positionDropdown);
      window.addEventListener('scroll', this.positionDropdown);
      this.positionDropdown();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.positionDropdown);
      window.removeEventListener('scroll', this.positionDropdown);
    }
  }, {
    key: "getRowProps",
    value: function getRowProps(result, index) {
      return {
        // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
        className: classNames('autocomplete-search-row', {
          hover: index === this.state.currentHoverIndex
        }),
        onClick: this.handleClick.bind(null, result, index),
        onMouseEnter: this.handleMouseOver.bind(null, index),
        // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
        key: _get(result, this.props.primaryKeyPath, index)
      };
    }
  }, {
    key: "getInputProps",
    value: function getInputProps() {
      return {
        // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
        value: this.state.inputValue,
        // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
        placeholder: this.props.placeholder,
        onChange: this.handleTypeaheadInput,
        onKeyDown: this.handleKeyDown,
        onBlur: this.handleBlur,
        onFocus: this.handleFocus
      };
    } // eslint-disable-next-line react/sort-comp -- directive added automatically by Shepherd migration

  }, {
    key: "handleTypeaheadInput",
    value: function handleTypeaheadInput(event) {
      var shouldHide = event.target.value.length === 0; // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration

      this.props.onChange(event.target.value);
      this.setState({
        inputValue: event.target.value,
        hideList: shouldHide
      });

      if (!shouldHide) {
        this.positionDropdown();
      }
    }
  }, {
    key: "handleClick",
    value: function handleClick(result, index, e) {
      // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
      this.props.onClick(result, index, e); // reset to initial state

      this.setState({
        inputValue: '',
        currentHoverIndex: null,
        hideList: true
      });
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(event) {
      if (event.which !== 27) {
        // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
        this.props.onKeyDown();
      } // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration


      if (this.props.results.length > 0) {
        // Key 9 = Tab, Key 40 = ArrowDown
        if (event.which === 9 || event.which === 40) {
          event.preventDefault(); // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration

          var hoverRow = this.state.currentHoverIndex !== null ? // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
          this.state.currentHoverIndex + 1 : 0;
          this.transitionHoverState(hoverRow); // Key 38 = ArrowUp
        } else if (event.which === 38) {
          event.preventDefault(); // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration

          var _hoverRow = this.state.currentHoverIndex !== null ? // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
          this.state.currentHoverIndex - 1 : // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
          this.props.results.length - 1;

          this.transitionHoverState(_hoverRow); // Key 27 = Esc
        } else if (event.which === 27) {
          this.setState({
            hideList: true
          });
        } else if (event.which === 13) {
          // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
          if (this.state.currentHoverIndex !== null) {
            this.handleClick( // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
            this.props.results[this.state.currentHoverIndex], // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
            this.state.currentHoverIndex, event);
          }
        }
      }
    }
  }, {
    key: "handleMouseOver",
    value: function handleMouseOver(index) {
      this.setState({
        currentHoverIndex: index
      });
    }
  }, {
    key: "handleMouseLeave",
    value: function handleMouseLeave() {
      this.setState({
        currentHoverIndex: null
      });
    }
  }, {
    key: "handleFocus",
    value: function handleFocus() {
      // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
      if (this.state.inputValue.length > 0) {
        this.positionDropdown(); // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration

        this.setState({
          hideList: this.props.showNoCardMessage
        });
      }
    }
  }, {
    key: "handleBlur",
    value: function handleBlur() {
      // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
      if (this.state.currentHoverIndex === null) {
        this.setState({
          hideList: true
        });
      }
    }
  }, {
    key: "transitionHoverState",
    value: function transitionHoverState(hoverRow) {
      var newHoverRow = hoverRow; // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration

      if (hoverRow > this.props.results.length - 1) {
        newHoverRow = 0;
      } else if (hoverRow < 0) {
        // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
        newHoverRow = this.props.results.length - 1;
      }

      if (!this.isElementInContainer(newHoverRow)) {
        this.resultsContainer.scrollTop = this.autocompleteList.getElementsByClassName('autocomplete-search-row')[newHoverRow].offsetTop;
      }

      this.setState({
        currentHoverIndex: newHoverRow
      });
    }
  }, {
    key: "isElementInContainer",
    value: function isElementInContainer(hoverRow) {
      var row = this.autocompleteList.getElementsByClassName('autocomplete-search-row')[hoverRow];
      var rect = row.getBoundingClientRect();
      var container = this.resultsContainer.getBoundingClientRect();
      return rect.bottom > container.top && rect.top < container.bottom;
    }
  }, {
    key: "renderRows",
    value: function renderRows() {
      var _this2 = this;

      // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
      var rows = this.props.results.map(function (result, index) {
        return React.createElement("div", _this2.getRowProps(result, index), _this2.props.renderRow(result));
      }); // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration

      var offerIds = this.props.results.map(function (result) {
        return result.id;
      });
      return React.createElement(Impression, {
        enabled: _get(this.props, "analytics.enabled"),
        entityName: "credit_card_search",
        eventType: "marketplace_offers_impression",
        payload: {
          section_name: _get(this.props, "analytics.payload.sectionName"),
          section_position: 0,
          additional_attributes: {
            marketplace_product_type: "credit_cards",
            // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
            marketplace_offers_count: this.props.results.length,
            marketplace_offer_ids: offerIds
          }
        }
      }, rows);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
      var noCardsFoundMessage = "We couldn't find credit cards for \"".concat(sanitizeHtml(this.state.inputValue), "\". Please try something else."); // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration

      var elementName = "credit-card-search".concat(this.props.trackingPostfix); // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration

      var trackingID = "credit-card-search".concat(this.props.trackingPostfix);
      var spinner = React.createElement("div", {
        className: "autocomplete-spinner-container"
      }, React.createElement(LoadingSpinner, {
        color: "green",
        size: 24,
        inline: true
      }));
      var inputValidation = {}; // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration

      if (!this.props.isLoading && this.props.showNoCardMessage) {
        inputValidation = {
          isValid: false,
          feedback: [noCardsFoundMessage]
        };
      }

      return React.createElement("div", {
        className: classNames('autocomplete-search-container', {
          // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
          'show-results': this.state.hideList === false
        }),
        ref: function ref(el) {
          return _this3.container = el;
        }
      }, React.createElement(ElementImpressionInteraction, {
        type: "CLICK",
        elementName: elementName,
        elementCategory: "input",
        id: trackingID
      }, React.createElement("div", {
        className: "autocomplete-search__input-container"
      }, React.createElement(LegacyInput // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
      , _extends({
        autoFocus: !this.props.disableAutofocus,
        className: "input-override"
      }, this.getInputProps(), {
        validation: inputValidation,
        fullWidth: true
      })), this.props.isLoading && spinner, !this.props.showNoCardMessage && !this.props.isLoading && React.createElement(Search, {
        className: "search"
      }))), React.createElement("div", {
        className: "autocomplete-search-results-list",
        onMouseLeave: this.handleMouseLeave,
        ref: function ref(el) {
          return _this3.resultsContainer = el;
        }
      }, React.createElement("div", {
        className: "autocomplete-search-rows",
        ref: function ref(el) {
          return _this3.autocompleteList = el;
        }
      }, this.renderRows())));
    }
  }]);

  return AutocompleteSearch;
}(Component);

_defineProperty(AutocompleteSearch, "displayName", 'Typeahead');

_defineProperty(AutocompleteSearch, "defaultProps", {
  analytics: {
    enabled: false,
    payload: {
      formName: "credit_card_search"
    }
  },
  onClick: function onClick() {},
  onKeyDown: function onKeyDown() {},
  isLoading: false,
  results: [],
  showNoCardMessage: false,
  trackingPostfix: ''
});

_defineProperty(AutocompleteSearch, "propTypes", {
  analytics: PropTypes.shape({
    enabled: PropTypes.bool,
    payload: PropTypes.shape({
      formName: PropTypes.string,
      sectionName: PropTypes.string
    })
  }),
  disableAutofocus: PropTypes.bool,
  isLoading: PropTypes.bool,
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  onKeyDown: PropTypes.func,
  placeholder: PropTypes.string,
  primaryKeyPath: PropTypes.string,
  renderRow: PropTypes.func,
  results: PropTypes.arrayOf(Card),
  showNoCardMessage: PropTypes.bool,
  trackingPostfix: PropTypes.string
});

export default AutocompleteSearch;